import { render, staticRenderFns } from "./DeliveryRangeSetting.vue?vue&type=template&id=61c03162"
import script from "./DeliveryRangeSetting.vue?vue&type=script&lang=js"
export * from "./DeliveryRangeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports